import React, { useMemo, useState } from "react";
import CustomModal from "../../customModal/CustomModal";
import "./MobileLoginModal.css";
import { MobileOTPVerification } from "../../../login/mobile/otpVerification/MobileOtpVerification";
import { MobileEmailContent } from "../../../login/mobile/enterEmailContent/MobileEmailContent";
import { OTPSuccessVerification } from "../../../login/mobile/otpSuccessVerification/OTPSuccessVerification";

type props = {
  isOpen: boolean;
  onClose: () => void;
};

export const MobileLoginModal: React.FC<props> = ({ isOpen, onClose }) => {
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();
  const [authToken, setAuthToken] = useState<string>();

  const renderChild = useMemo(() => {
    return authToken ? (
      <OTPSuccessVerification authToken={authToken} />
    ) : isOtpSent ? (
      <MobileOTPVerification email={email ?? ""} setAuthToken={setAuthToken} />
    ) : (
      <MobileEmailContent
        setIsOtpSent={setIsOtpSent}
        setEmail={setEmail}
        email={email}
      />
    );
  }, [email, isOtpSent, authToken]);

  const handleCloseClicked = () => {
    onClose();
    setTimeout(() => {
      setIsOtpSent(false);
      setEmail("");
    }, 1000);
  };

  return (
    <CustomModal isOpen={isOpen} isHideCloseButton onClose={handleCloseClicked}>
      {renderChild}
    </CustomModal>
  );
};
